import google from './google'

const services = { google }

export default services
